/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Published_BannerInputs */

const en_directory_submit_enrich_published_banner = /** @type {(inputs: Directory_Submit_Enrich_Published_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your tool has been published.`)
};

const zh_directory_submit_enrich_published_banner = /** @type {(inputs: Directory_Submit_Enrich_Published_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的工具已发布。`)
};

/**
* | output |
* | --- |
* | "Your tool has been published." |
*
* @param {Directory_Submit_Enrich_Published_BannerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_published_banner = /** @type {((inputs?: Directory_Submit_Enrich_Published_BannerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Published_BannerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_published_banner(inputs)
	return zh_directory_submit_enrich_published_banner(inputs)
});
export { directory_submit_enrich_published_banner as "directory.submit.enrich.published_banner" }